import { LiveCallsDefault } from '../components/features'
import { CrashSafeWrapper } from '../components/CrashSafeWrapper'

const LiveCalls = () => {
  return (
    <CrashSafeWrapper level="page" name="LiveCalls">
      <LiveCallsDefault/>
    </CrashSafeWrapper>
  )
}

export default LiveCalls
